import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "event-reference"
    }}>{`Event Reference`}</h1>
    <p>{`Events dispatched by the Lifecycle extension to support Adobe Experience Platform Edge Network workflows include:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../home/base/mobile-core/lifecycle/event-reference.md#lifecycle-application-foreground"
        }}>{`Lifecycle Application Foreground`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../home/base/mobile-core/lifecycle/event-reference.md#lifecycle-application-background"
        }}>{`Lifecycle Application Background`}</a></li>
    </ul>
    <p>{`For full event details, please read the `}<a parentName="p" {...{
        "href": "../../home/base/mobile-core/lifecycle/event-reference.md"
      }}>{`Lifecycle event reference`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      